import { render, staticRenderFns } from "./addCateDialog.vue?vue&type=template&id=05515d9e&scoped=true&"
import script from "./addCateDialog.vue?vue&type=script&lang=js&"
export * from "./addCateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05515d9e",
  null
  
)

export default component.exports